export const GET_QUALIFICATION_HISTORY =
  'app/ApplicationProfile/QualificationTab/GET_QUALIFICATION_HISTORY';
export const GET_QUALIFICATION_HISTORY_SUCCESS =
  'app/ApplicationProfile/QualificationTab/GET_QUALIFICATION_HISTORY_SUCCESS';
export const GET_QUALIFICATION_HISTORY_ERROR =
  'app/ApplicationProfile/QualificationTab/GET_QUALIFICATION_HISTORY_ERROR';

export const UPDATE_HOUSEHOLD_HISTORY =
  'app/QualificationHistoryTab/UPDATE_HOUSEHOLD_HISTORY';
